export const getErrorMessage = (err, defaultMessage = 'Ocorreu um erro inesperado.') => {
    const detail = err?.response?.data?.detail;
    if (!detail) return defaultMessage;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail.map((e) => e.msg || String(e)).join(', ');
    }
    return defaultMessage;
};
